import filter from "./filter"
import "./_reward.scss"
import "./_rewards.scss"

require.context("./", true, /\.(png|jpg|webp|svg|gif)$/)

const REWARDS_CLASS_NAME = "js-rewards"

export default function setListeners() {
  Array.from(document.getElementsByClassName(REWARDS_CLASS_NAME)).map(filter)
}
